import React, {useContext} from 'react';
import {INotificationModel, NotificationTypes} from '../../../@interfaces/models/Notification/INotificationModel';
import UnknownNotification from '../UnknownNotification';
import {INotificationProps} from '../../../@interfaces/components/Notifications/INotificationProps';
import CannotFindOwnerOfFile from './Order/Product/File/CannotFindOwnerOfFile';
import trans from '../../../helpers/trans';
import {LocaleContext} from '../../../contexts/LocaleContext';
import {default as OrderManagerChanged} from './Order/ManagerChanged';
import {default as OrderStatusChanged} from './Order/StatusChanged';
import {default as ProductStatusChanged} from './Order/Product/StatusChanged';
import {default as OrderDeadlineChanged} from './Order/DeadlineChanged';
import {default as ProductDeadlineChanged} from './Order/Product/DeadlineChanged';
import {default as OrderCommentAdded} from './Order/CommentAdded';
import {default as ProductCommentAdded} from './Order/Product/CommentAdded';
import {default as ProductFileUploaded} from './Order/Product/File/FileUploaded';
import DeadlineWillExpireSoon from './Order/DeadlineWillExpireSoon';
import StatusLifetimeWillExpireSoon from './Order/StatusLifetimeWillExpireSoon';
import DeadlineExpired from './Order/DeadlineExpired';
import StatusLifetimeExpired from './Order/StatusLifetimeExpired';
import StatusLifetimeProlonged from './Order/StatusLifetimeProlonged';

export type ServerNotificationProps<T extends NotificationTypes> = {
    notification: INotificationModel<T>,
};

export function getNotificationComponent(type: NotificationTypes) {
    switch (type) {
        case 'App\\Notifications\\Order\\Product\\File\\CannotFindOwnerOfFile':
            return CannotFindOwnerOfFile;

        case 'App\\Notifications\\Order\\ManagerChanged':
            return OrderManagerChanged;

        case 'App\\Notifications\\Order\\StatusChanged':
            return OrderStatusChanged;

        case 'App\\Notifications\\Order\\Product\\StatusChanged':
            return ProductStatusChanged;

        case 'App\\Notifications\\Order\\DeadlineChanged':
            return OrderDeadlineChanged;

        case 'App\\Notifications\\Order\\Product\\DeadlineChanged':
            return ProductDeadlineChanged;

        case 'App\\Notifications\\Order\\CommentAdded':
            return OrderCommentAdded;

        case 'App\\Notifications\\Order\\Product\\CommentAdded':
            return ProductCommentAdded;

        case 'App\\Notifications\\Order\\Product\\File\\FileUploaded':
            return ProductFileUploaded;

        case 'App\\Notifications\\Order\\DeadlineWillExpireSoon':
            return DeadlineWillExpireSoon;

        case 'App\\Notifications\\Order\\StatusLifetimeWillExpireSoon':
            return StatusLifetimeWillExpireSoon;

        case 'App\\Notifications\\Order\\DeadlineExpired':
            return DeadlineExpired;

        case 'App\\Notifications\\Order\\StatusLifetimeExpired':
            return StatusLifetimeExpired;

        case 'App\\Notifications\\Order\\StatusLifetimeProlonged':
            return StatusLifetimeProlonged;

        default:
            break;
    }

    return UnknownNotification;
}

export default function ServerNotification<T extends NotificationTypes>(props: ServerNotificationProps<T>) {
    const {locale} = useContext(LocaleContext);

    const notificationType = props.notification.type.replace('App\\Notifications\\', '');
    const baseName = notificationType.replace(/\\+/guim, '-');

    const notificationProps: INotificationProps = {
        ...props.notification,
        type: 'custom',
        color: 'info',
        title: `Notifications:${baseName}.title`,
        description: `Notifications:${baseName}.description`,
        readTrigger: 'click',
    };

    const Notification: React.ComponentType<any> = getNotificationComponent(props.notification.type);
    if (Notification === UnknownNotification) {
        notificationProps.title = 'Notifications:UnknownNotification.title';
        notificationProps.description = trans(
                'Notifications:UnknownNotification.description',
                {
                    name: notificationType,
                },
                undefined,
                locale
        );
    }

    return <Notification {...notificationProps} {...props}/>;
}
